import { useContext } from 'react'
import { OnceOffExportContext } from 'contexts/onceOffExportContext'

export const useOnceOffExportContext = () => {
  return useContext(OnceOffExportContext)
}
